
import BaseMixin from '@/views/mixin.vue'
import compSearch from './search'
import { mapState,mapGetters} from 'vuex'
import {
    HttpB2cList,
    HttpCancelOrder,
    HttpResetOrder,
    HttpRecoveryNormal,

    HttptoExamine,
    HttpPushFbb,
    HttpComuteCosts,
    HttpChangeOrder,
    HttpAddorderSign,
    HttpCloseOrder,
    HttpDownSurFaceOrder,
    HttpCheckOtherOrder,
    HttpGetAllLabel,
    HttpSaveLabel,
    HttpOrderAddLabel,
    HttpOrderRemoveLabel,
    HttpTrackingComeback,
    HttpMfnManuallyCheck,
    HttpInviteComment
} from '@/service/boss/b2corder'
import comDisassOrder from '../alert/disassemble'
import comActiveOrder from '../alert/activeorder'
import cancelorder from '../alert/cancelorder'
import comOrderimport from '../alert/orderimport'
import comLogisticList from '../alert/logisticlist'
import comModifywarehouse from '../alert/modifywarehouse'
import comAddnotes from '../alert/addnotes'
import comAbnomal from '../alert/abnomal'
import comIndex from '../update/index'
import comImport from './compimport'
import comPassprove from '../alert/passprove'
import compUploadOrder from './comUpload'
import compSendTime from '../alert/sendtime'
import compSwitchIssueMethod from '../alert/switchissuemethod'
import compExportPickup from '../alert/exportpickup'
import detailReplacement from './detailReplacement'

import { DropdownMenu, Dropdown, DropdownItem, Icon, Button, Tooltip } from 'view-design'
import { resolve } from 'core-js/fn/promise'


export default {
    mixins: [BaseMixin],
    components: {
        compSearch,
        comDisassOrder,
        comActiveOrder,
        cancelorder,
        comOrderimport,
        comLogisticList,
        comModifywarehouse,
        comAddnotes,
        comAbnomal,
        comIndex,
        comImport,
        comPassprove,
        compUpload: () =>  import("@components/templates/upload"),
        compUploadOrder,
        compSendTime,
        compSwitchIssueMethod,
        compExportPickup,
        detailReplacement
    },
    data() {
        return {
            // title: "B2C订单",
            isSuper: this.$store.state.userinfo.isSuper,
            hongren:'/picture/hongren.png',
            prime:'/picture/prime.png',
            bufa:'/picture/bufa.png',
            fudingdan:0,
            b2cPriceInfo:false,
            keyword: this.$route.query.keyword,
            labelList: [],
            inviteCount:[
                {
                    value: 0,
                    label: this.$t('erp.b2c.no_request', { defaultValue: '未请求'}),
                },
                {
                    value: 1,
                    label: this.$t('erp.b2c.requesting', { defaultValue: '请求中'}),
                },
                {
                    value: 2,
                    label: this.$t('erp.b2c.request_success', { defaultValue: '请求成功'}),
                },
                {
                    value: 3,
                    label: this.$t('erp.b2c.request_failed', { defaultValue: '请求失败'}),
                },
            ]
        };
    },
    created() {
        this.b2cPriceInfo = this.handleAuth('erp.b2cOrder.indexPrice');
        this.b2cOrderset = this.handleAuth('erp.b2cOrder.set');
        // console.log(this.b2cPriceInfo)
        let labelList = localStorage.getItem('@b2clabel');
        this.labelList = labelList ? labelList : [];
        this.getLabelData();
    },
    mounted () {
        if (this.keyword) {
            this.$refs.compsearch.isOpen = true
        }
        this.$refs.compsearch.formData['EQ_keyword'] = this.keyword
        this.updateSearch({ search: this.$refs.compsearch.formData, page: 1 })
    },
    methods: {
        getLabelData () {
            HttpGetAllLabel({
                module: 26
            }).then(res => {
                this.labelList = res.data;
                localStorage.setItem('@b2clabel', res.data);
            }, err => {
                this.$VMessage.error(err.message);
            });
        },
        async handleLabelChange (changeMap) {
            await changeMap.forEach(async (value, key, map) => {
                await HttpSaveLabel({
                    id: key,
                    labelId: value.labelId,
                    labelName: value.labelName,
                    labelColour: value.labelColour,
                    module: 26
                }).then(res => {
                    this.$VMessage.success(res.message);
                    this.labelList = res.data;
                }, err => {
                    this.$VMessage.error(err.message);
                });
            });
            // setTimeout(() => {
            //     this.getLabelData();
            // }, 200)
        },
        downloadExcel(url){
            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + url, {contextId: global.SYSID}, 'download')
        },
        httpList: HttpB2cList,
        handleLabel (type, labelIds) {
            let params = this.checkedId.join(',')
            if (!this.checkedId.join(',').length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            // console.log(type, labelIds);
            switch (type) {
                case 'add':
                    HttpOrderAddLabel({
                        labelIds: labelIds.join(','),
                        orderIds: params,
                        singleFlag: 0
                    }).then(res => {
                        // console.log(res);
                        this.$nextTick(() => {
                            // this.$refs.compsearch.formData['IN_orderLabelEntities.labelId'] = '';
                            this.updateSearch({ search: this.$refs.compsearch.formData });
                        });
                        this.$VMessage.success(res.message);
                    }, err => {
                        this.$VMessage.error(err);
                    })
                    break;
                case 'remove':
                    HttpOrderRemoveLabel({
                        labelIds: labelIds.join(','),
                        orderIds: params
                    }).then(res => {
                        // console.log(res);
                        this.$nextTick(() => {
                            // this.$refs.compsearch.formData['IN_orderLabelEntities.labelId'] = '';
                            this.updateSearch({ search: this.$refs.compsearch.formData });
                        });
                        this.$VMessage.success(res.message);
                    }, err => {
                        this.$VMessage.error(err);
                    })
                    break;
            }
        },
        handleDeleteSearch (callback) {
            this.$VModal.error({
                title: this.$t('erp.b2corder.search_modal_delete_query_title', { defaultValue: '删除收藏查询' }),
                content: this.$t('erp.b2corder.search_modal_delete_query_desc', { defaultValue: '确定删除收藏的查询？' }),
                async: true,
            }, {
                'on-after-close': () => {
                    this.$VModal.destroy();
                },
                'on-confirm': () => {
                    callback(() => {
                        this.$VModal.destroy();
                    })
                }
            })
        },
        handleOperates(params='', type) {
            this.operate = {};
            switch (type) {
                case 'query':
                    this.operate = {
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeids:params,
                        querytype:'query'
                    }
                    break;
                case 'queryBlank':
                    const url = this.$router.resolve({
                        name: 'b2cOrderupdate',
                        params: { type: 'query' },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case 'getReplacementDetails':
                    this.operate = {
                        title: this.$t('erp.b2c.exchange_details',{defaultValue:'换货明细'}),
                        show: true,
                        width: '800',
                        component: "detailReplacement",
                        id:params.id,
                        showFooter: false,
                        initFormData:{
                            "channelFlag":params.channelFlag,
                            'orderNo':params.orderNo,
                        }
                    }
                    break;
                case 'orderImport':
                    this.operate = {
                        title: this.$t('erp.b2c.import_order',{defaultValue:'订单导入'}),
                        show:true,
                        width:600,
                        component: "comOrderimport",
                        activeids:params,
                    }
                    break;
                case 'querylogistic':
                    // console.log(params,'logisticdatalogisticdata')
                    this.operate = {
                        title: this.$t('global.common.operation_see',{defaultValue:'查看'}),
                        show:true,
                        width:400,
                        component: "comLogisticList",
                        logisticlist:params,
                    }
                    break;
                case 'trackingImport':
                    this.operate = {
                        show: true,
                        title: 'Tracking' + this.$t('global.common.import',{defaultValue:'导入'}),
                        width:460,
                        showFooter: false,
                        data: { contextId: global.SYSID},
                        action: process.env.VUE_APP_APIURL_BOSS + "/api/v2/B2cOrder/trackingImport",
                        name: "excelFile",
                        component: "compUpload",
                        // download:this.downloadExcel("/api/v2/B2cOrder/trackingImportTemplate"),
                        download:()=>{
                            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS +'/api/v2/B2cOrder/trackingImportTemplate','download')
                        },
                        warningtitle: this.$t('erp.b2c.tracking_import'),
                    }
                    break;
                case 'deliveryOrderImport':
                    this.operate = {
                        show: true,
                        title: this.$t('erp.b2c.import_data',{defaultValue:'导入数据'}),
                        width:460,
                        showFooter: false,
                        data: {
                            contextId: global.SYSID
                        },
                        action: process.env.VUE_APP_APIURL_BOSS + "/api/v2/B2cOrder/deliveryOrderImport",
                        name: "excelFile",
                        download:()=>{
                            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS +'/api/v2/B2cOrder/deliveryOrderTemplate','download')
                        },
                        warningtitle:this.$t('erp.b2c.deleveryoder_import'),
                        // component: "compUpload",
                        propsData: {
                            data: {
                                contextId: global.SYSID
                            },
                            action: process.env.VUE_APP_APIURL_BOSS + "/api/v2/B2cOrder/deliveryOrderImport",
                            name: "excelFile",
                            download:()=>{
                                this.handleWebfs(process.env.VUE_APP_APIURL_BOSS +'/api/v2/B2cOrder/deliveryOrderTemplate','download')
                            },
                            warningtitle:this.$t('erp.b2c.deleveryoder_import'),
                        },
                        component: "compUploadOrder",
                        // download:this.downloadExcel("/api/v2/B2cOrder/deliveryOrderTemplate"),
                    };
                    break;
                case 'wordImport':
                    this.operate = {
                        show: true,
                        title: this.$t('erp.b2c.arrachement_upload',{defaultValue:'附件上传'}),
                        width:460,
                        showFooter: false,
                        actionurl: "/api/v2/B2cOrder/uploadAnnex",
                        name: "excelFile",
                        comptitle:this.$t('erp.b2c.attachment_type',{defaultValue:'附件类型'}),
                        component: "comImport",
                        warningtitle:this.$t('erp.b2c.arrachement_tip'),
                    };
                    break;
                case 'exportPickup':
                    this.operate = {
                        show: true,
                        title: this.$t('erp.b2c.export_pickup', { defaultValue: "pickup导出" }),
                        width: 460,
                        showFooter: false,
                        component: "compExportPickup"
                    };
                    break;
                case 'edit': {
                    const url = this.$router.resolve({
                        name: 'b2cOrderupdate',
                        params: { type: 'edit' },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                }
                case 'cancel': {
                    if(params.isDismantlement == 'Y' && params.isDismantlement != 0){
                        HttpCheckOtherOrder({
                            orderId:params.id
                        }).then(res=>{
                            if(res.data){
                                // this.showDel = true;
                                this.$VModal.info({
                                    title: this.$t('erp.b2c.cancel_sub_order',{defaultValue:'取消子订单'}),
                                    content: this.$t('erp.b2c.parent_order_associated',{defaultValue:'该子订单关联的父订单有其他未取消的子订单，确定取消吗？'}),
                                    async: true,
                                }, {
                                    'on-after-close': () => {
                                        this.$VModal.destroy();
                                    },
                                    'on-confirm': (name) => {
                                        // console.log(676767676)
                                        this.$VModal.destroy();
                                        this.cancelbox(params,type)
                                    }
                                })
                            }else{
                                this.cancelbox(params,type)
                            }
                        },err=>{
                            this.$Message.error({content:err.message,duration: 10,closable: true})
                        })

                    }else{
                        this.cancelbox(params,type)
                    }
                    break;
                }
                case 'dismantling': {
                    this.operate = {
                        title: this.$t('erp.b2c.operate_dismantling',{defaultValue:'拆解'}),
                        show:true,
                        width:1000,
                        component: "comDisassOrder",
                        type,
                        id:params,
                    }
                    break;
                }
                // search
                case 'resetorder': {
                    this.checkedId = !params ? this.checkedId : [params];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    this.showDel = true;
                    this.operate = {
                        title: this.$t('erp.b2c.reset_order',{defaultValue:'重置订单'}),
                        desc: this.$t('erp.b2c.resetorder_desc',{defaultValue:'订单重置后会恢复初始状态，并变为手工订单，是否确认提交？'}),
                        type,
                    }
                    break;
                }
                case 'activeorder': {
                    this.checkedId = !params ? this.checkedId : [params];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    this.operate = {
                        title: this.$t('erp.b2c.active_order',{defaultValue:'激活订单'}),
                        show:true,
                        width:600,
                        component: "comActiveOrder",
                        activeids:this.checkedId,
                    }
                    break;
                }
                case 'backnormal': {
                    this.checkedId = !params ? this.checkedId : [params];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    this.showDel = true;
                    this.operate = {
                        title: this.$t('erp.b2c.back_normal',{defaultValue:'恢复正常'}),
                        desc: this.$t('erp.b2c.backnormal_desc',{defaultValue:'确定要将订单恢复为正常处理的订单？'}),
                        type,
                    }
                    break;
                }

                case 'project': {
                    this.checkedId = !params ? this.checkedId : [params];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    this.showDel = true;
                    this.operate = {
                        title: this.$t('erp.b2c.project_manual',{defaultValue:'项目手动关联'}),
                        desc:  this.$t('erp.b2c.projectmanual_desc',{defaultValue:'确定手动关联项目？请先确认渠道产品已经添加'}),
                        type,
                    }
                    break;
                }
                case 'passapprove': {
                    this.checkedId = !params ? this.checkedId : [params];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    // this.showDel = true;
                    this.operate = {
                        title: this.$t('erp.b2c.approved',{defaultValue:'审核通过'}),
                        show:true,
                        width:600,
                        component: "comPassprove",
                        activeids:this.checkedId,
                    }
                    // this.operate = {
                    //     title: this.$t('erp.b2c.approved',{defaultValue:'审核通过'}),
                    //     desc: this.$t('erp.b2c.approved_desc',{defaultValue:'确定审核该订单？审核通过后，订单会自动进入订单处理流程'}),
                    //     type,
                    // }
                    break;
                }
                case 'sendyuncang': {
                    // 推送云仓
                    this.checkedId = !params ? this.checkedId : [params];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }else{
                        this.pushsubmit('sendyuncang')
                    }
                    break;
                }
                case 'forcedpush': {
                    // 强制推送
                    this.checkedId = !params ? this.checkedId : [params];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }else{
                        this.showDel = true;
                        this.operate = {
                            title: this.$t('erp.b2c.forced_push',{defaultValue:'强制推送'}),
                            desc: this.$t('erp.b2c.forcedpush_desc',{defaultValue:'强制推送时不会检查附件和订单状态，请确认订单状态，需要附件的订单必须上传附件，再点击强制推送'}),
                            type,
                        }
                        // this.pushsubmit('forcedpush')
                    }
                    break;
                }
                case 'loadcost': {
                    this.checkedId = !params ? this.checkedId : [params];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    else{
                        this.pushsubmit('loadcost')
                    }
                    break;
                }
                case 'resetcost': {
                    this.checkedId = !params ? this.checkedId : [params];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    else{
                        this.pushsubmit('resetcost')
                    }
                    break;
                }
                case 'normalsales': {
                    this.checkedId = !params ? this.checkedId : [params];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    this.showDel = true;
                    this.operate = {
                        title: this.$t('erp.b2c.modify_order',{defaultValue:'修改订单类型'}),
                        desc: this.$t('erp.b2c.modifyorder_type',{defaultValue:'确定修改订单类型为正常销售？'}),
                        type,
                    }
                    break;
                }
                case 'displayorder': {
                    this.checkedId = !params ? this.checkedId : [params];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    this.showDel = true;
                    this.operate = {
                        title: this.$t('erp.b2c.modify_order',{defaultValue:'修改订单类型'}),
                        desc: this.$t('erp.b2c.diaplayor_order',{defaultValue:'确定修改订单类型为展示订单？'}),
                        type,
                    }
                    break;
                }
                case 'distributeorder': {
                    this.checkedId = !params ? this.checkedId : [params];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    this.showDel = true;
                    this.operate = {
                        title: this.$t('erp.b2c.modify_order',{defaultValue:'修改订单类型'}),
                        desc: this.$t('erp.b2c.distribute_order',{defaultValue:'确定修改订单类型为分销订单？'}),
                        type,
                    }
                    break;
                }
                case 'revieworder': {
                    this.checkedId = !params ? this.checkedId : [params];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    this.showDel = true;
                    this.operate = {
                        title: this.$t('erp.b2c.modify_order',{defaultValue:'修改订单类型'}),
                        desc: this.$t('erp.b2c.review_order',{defaultValue:'确定修改订单类型为刷评订单？'}),
                        type,
                    }
                    break;
                }
                case 'deliveryOrder': {
                    this.checkedId = !params ? this.checkedId : [params];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    this.showDel = true;
                    this.operate = {
                        title: this.$t('erp.b2c.modify_order',{defaultValue:'修改订单类型'}),
                        desc: this.$t('erp.b2c.delivery_order',{defaultValue:'确定修改订单类型为发货订单？'}),
                        type,
                    }
                    break;
                }
                case 'disassembleorder': {
                    this.checkedId = !params ? this.checkedId : [params];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    this.showDel = true;
                    this.operate = {
                        title: this.$t('erp.b2c.add_ordermark',{defaultValue:'增加订单标记'}),
                        desc: this.$t('erp.b2c.disassembleorder_desc',{defaultValue:'确定为订单增加一个订单标记为拆解订单？'}),
                        type,
                    }
                    break;
                }
                case 'additionalorder': {
                    this.checkedId = !params ? this.checkedId : [params];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    this.showDel = true;
                    this.operate = {
                        title: this.$t('erp.b2c.add_ordermark',{defaultValue:'增加订单标记'}),
                        desc: this.$t('erp.b2c.additional_desc',{defaultValue:'确定为订单增加一个订单标记为附加订单？'}),
                        type,
                    }
                    break;
                }
                case 'reissueorder': {
                    this.checkedId = !params ? this.checkedId : [params];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    this.showDel = true;
                    this.operate = {
                        title: this.$t('erp.b2c.add_ordermark',{defaultValue:'增加订单标记'}),
                        desc: this.$t('erp.b2c.replacementorder_desc',{defaultValue:'确定为订单增加一个订单标记为补发订单？'}),
                        type,
                    }
                    break;
                }
                case 'redpeopleorder': {
                    this.checkedId = !params ? this.checkedId : [params];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    this.showDel = true;
                    this.operate = {
                        title: this.$t('erp.b2c.add_ordermark',{defaultValue:'增加订单标记'}),
                        desc: this.$t('erp.b2c.redpeople_desc',{defaultValue:'确定为订单增加一个订单标记为红人订单？'}),
                        type,
                    }
                    break;
                }
                case 'sampleorder': {
                    this.checkedId = !params ? this.checkedId : [params];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    this.showDel = true;
                    this.operate = {
                        title: this.$t('erp.b2c.add_ordermark',{defaultValue:'增加订单标记'}),
                        desc: this.$t('erp.b2c.sampleorder_desc',{defaultValue:'确定为订单增加一个订单标记为样品订单？'}),
                        type,
                    }
                    break;
                }
                case 'modifylogistics': {
                    this.checkedId = !params ? this.checkedId : [params];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    this.operate = {
                        title: this.$t('erp.b2c.modify_logistics',{defaultValue:'修改仓库物流'}),
                        show:true,
                        width:600,
                        component: "comModifywarehouse",
                        activeids:this.checkedId,
                    }
                    break;
                }
                case 'addnotes': {
                    this.checkedId = !params ? this.checkedId : [params];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    this.operate = {
                        title: this.$t('erp.b2c.add_notes',{defaultValue:'添加备注'}),
                        show:true,
                        width:600,
                        component: "comAddnotes",
                        activeids:this.checkedId,
                    }
                    break;
                }
                case 'submitabnormal': {
                    this.checkedId = !params ? this.checkedId : [params];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    this.operate = {
                        title: this.$t('erp.b2c.submit_abnormal',{defaultValue:'提交异常'}),
                        show:true,
                        width:600,
                        component: "comAbnomal",
                        activeids:this.checkedId,
                    }
                    break;
                }
                case 'handerclose': {
                    this.checkedId = !params ? this.checkedId : [params];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    this.showDel = true;
                    this.operate = {
                        title: this.$t('erp.b2c.manual_override',{defaultValue:'手动关闭'}),
                        desc: this.$t('erp.b2c.manualoverride_desc',{defaultValue:'确定要关闭订单？'}),
                        type,
                    }
                    break;
                }
                case 'removeexcept': {
                    this.checkedId = !params ? this.checkedId : [params];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    this.showDel = true;
                    this.operate = {
                        title: this.$t('erp.b2c.back_normal_onlyremove',{defaultValue:'恢复正常 (仅去除异常)'}),
                        desc: this.$t('erp.b2c.backnormal_onlyremovedesc',{defaultValue:"该操作仅去除订单的异常类型，不会进入订单自动处理流程"}),
                        type,
                    }
                    break;
                }
                case 'downorder': {
                    this.checkedId = !params ? this.checkedId : [params];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    // this.showDel = true;
                    this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/B2cOrder/download', { orderIds: this.checkedId.join(',') }, {
                        executor: 'request',
                        download: true,
                        fileName: "download.zip"
                    }).catch(err => {
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true
                        });
                    });
                    break;
                }
                case 'addgiftlist':{
                    const url = this.$router.resolve({
                        name: 'addgiftlist',
                        params: { type: 'query' },
                        query: { id: ''},
                    });
                    window.open(url.href, '_blank');
                    break;
                }
                case 'changesendtime': {
                    this.checkedId = !params ? this.checkedId : [params];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    this.operate = {
                        show: true,
                        title: this.$t('erp.distribution.change_lastest_send_time', { defaultValue: '修改最晚发货时间' }),
                        component: "compSendTime",
                        activeids:this.checkedId,
                        showFooter: false
                    }
                    break;
                }
                case 'trackingComeback':
                    this.checkedId = !params ? this.checkedId : [params];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    this.showDel = true;
                    this.operate = {
                        title: this.$t('erp.b2c.tracking_comeback',{defaultValue:'tracking提前回传'}),
                        desc: this.$t('erp.b2c.tracking_comebackdetail',{defaultValue:'tracking提前回传内容'}),
                        type,
                    }
                    break;
                case 'batchlineprod': {
                    this.checkedId = !params ? this.checkedId : [params];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    this.showDel = true;
                    this.operate = {
                        title: this.$t('erp.b2c.batchline_prod',{defaultValue:'批量获取项目、产品'}),
                        desc: this.$t('erp.b2c.batchline_prod_desc',{defaultValue:'确定要批量获取项目、产品?'}),
                        type,
                    }
                    break;
                }
                case 'switchissuemethod': {
                    this.checkedId = !params ? this.checkedId : [params];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    this.operate = {
                        show: true,
                        width: 460,
                        title: this.$t('erp.b2c.switch_issue_method', { defaultValue: '切换出库方式' }),
                        component: "compSwitchIssueMethod",
                        activeids:this.checkedId,
                        showFooter: false,
                        on: {
                            'on-update': (res) => {
                                this.updateSearch();
                            },
                        }
                    }
                    break;
                }
                case 'review': {
                    this.checkedId = !params ? this.checkedId : [params];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    this.showDel = true;
                    this.operate = {
                        title: this.$t('',{defaultValue:'邀请评论'}),
                        desc: this.$t('erp.b2c.inviteComment_desc',{defaultValue:'是否发起邀请评论？'}),
                        type,
                    }
                    break;
                }

            }
        },
        cancelbox(data,type){
            this.operate = {
                title: this.$t('erp.b2c.cancel_order',{defaultValue:'取消订单'}),
                show:true,
                width:600,
                component: "cancelorder",
                isAdmin: 0,
                type,
                dataParam:data,
                warehouseList:this.getNewWarehouseIdList,
            }
        },
        async batchOpearte() {
            let request, { type, id } = this.operate, params = {}, callback = (res) => { this.$Message.success({content:res.message,duration: 10,closable: true}); };
            switch (type) {
                case 'cancel': request = HttpCancelOrder; params = { orderId:this.operate.id }; break;
                case 'resetorder': request = HttpResetOrder; params = { orderIds: this.checkedId.join(',') }; break;
                case 'backnormal': request = HttpRecoveryNormal; params = { orderIds: this.checkedId.join(','),recoveryNormal:1}; break;
                case 'project': ; break;
                case 'passapprove': request = HttptoExamine; params = { orderIds: this.checkedId.join(',') }; break;

                case 'forcedpush': request = HttpPushFbb; params = { orderIds: this.checkedId.join(','), node:1 }; break;

                case 'normalsales': request = HttpChangeOrder; params = { orderIds: this.checkedId.join(','), orderType:0 }; break;
                case 'displayorder': request = HttpChangeOrder; params = { orderIds: this.checkedId.join(','), orderType:1 }; break;
                case 'distributeorder': request = HttpChangeOrder; params = { orderIds: this.checkedId.join(','), orderType:2 }; break;
                case 'revieworder': request = HttpChangeOrder; params = { orderIds: this.checkedId.join(','), orderType:3}; break;
                case 'deliveryOrder': request = HttpChangeOrder; params = { orderIds: this.checkedId.join(','), orderType:4}; break;

                case 'disassembleorder': request = HttpAddorderSign; params = { orderIds: this.checkedId.join(','), orderSign:5 }; break;
                case 'additionalorder': request = HttpAddorderSign; params = { orderIds: this.checkedId.join(','), orderSign:4 }; break;
                case 'reissueorder': request = HttpAddorderSign; params = { orderIds: this.checkedId.join(','), orderSign:3 }; break;
                case 'redpeopleorder': request = HttpAddorderSign; params = { orderIds: this.checkedId.join(','), orderSign:1 }; break;
                case 'sampleorder': request = HttpAddorderSign; params = { orderIds: this.checkedId.join(','), orderSign:2 }; break;
                case 'handerclose': request = HttpCloseOrder; params = { orderIds: this.checkedId.join(',') }; break;

                case 'removeexcept': request = HttpRecoveryNormal; params = { orderIds: this.checkedId.join(','),recoveryNormal:0 }; break;
                case 'trackingComeback': request = HttpTrackingComeback; params = { orderIds: this.checkedId.join(',') }; break;
                case 'batchlineprod': request = HttpMfnManuallyCheck; params = { orderIds: this.checkedId.join(',') }; break;

                case 'review': request = HttpInviteComment; params = { orderIds: this.checkedId.join(',') }; break;
            }
            if (!request) return;
            request(params).then(res => {
                this.$Message.success({content:res.message,duration: 10,closable: true});
                this.updateList();
                // console.log(this.checkedId)
            }, err => {
                this.$Message.error({content:err.message,duration: 10,closable: true});
            }).finally(result => {
                this.showDel = false;
                this.operate = {};
            });
        },
        pushsubmit(type){
            let request, params = {}, callback = (res) => { this.$Message.success({content:res.message,duration: 10,closable: true}); };
            switch (type) {
                case 'sendyuncang': request = HttpPushFbb; params = { orderIds: this.checkedId.join(','), node:0 }; break;
                // case 'forcedpush': request = HttpPushFbb; params = { orderIds: this.checkedId.join(','), node:1 }; break;

                case 'loadcost': request = HttpComuteCosts; params = { orderIds: this.checkedId.join(','), node:0 }; break;
                case 'resetcost': request = HttpComuteCosts; params = { orderIds: this.checkedId.join(','), node:1 }; break;

            }
            if (!request) return;
            request(params).then(res => {
                this.$Message.success({content:res.message,duration: 10,closable: true});
                this.updateList();
            }, err => {
                this.$Message.error({content:err.message,duration: 10,closable: true});
            });
        },
        // 操作下的列表展示内容
        getOperateNodeMap(row){
            const { id, fulfillmentChannel, orderStatus,parentId,isDismantlement } = row
            return [{
                label:this.$t('global.common.operation_see',{defaultValue:'查看'}),
                show:true,
                params:id,
                operate:'query'
            },{
                label:this.$t('global.common.operation_edit',{defaultValue:'编辑'}),
                show:fulfillmentChannel=='MFN' && (orderStatus=='pending' || orderStatus=='unshipped' || orderStatus=='approved') && !(parentId==0 && isDismantlement=='Y') && this.b2cOrderset,
                to: {
                    name: 'b2cOrderupdate',
                    params: { type: 'edit' },
                    query: { id },
                },
            },{
                label:this.$t('global.common.operation_cancel',{defaultValue:'取消'}),
                show: orderStatus!='shipped' && orderStatus!='canceled' && !(parentId==0 && isDismantlement=='Y') && this.b2cOrderset,
                params:row,
                operate:'cancel'
            },{
                label:this.$t('erp.b2c.operate_dismantling',{defaultValue:'拆解'}),
                show:fulfillmentChannel=='MFN' && orderStatus!='picked' && orderStatus!='shipped' && orderStatus!='canceled' && orderStatus!='assigned',
                params:id,
                operate:'dismantling'
            }]
        },
        getLogistics (value) {
            // console.log(value,'valuevalue')
            let result = this.packStatus.filter(item => {
                return item.value === value
            })[0]
            if (!result || !result.label) return <div>--</div>
            return <span class={result.color}>{result.label}</span>
        },
    },
    computed: {
        ...mapGetters('diction',['getNewProductList','getNewWarehouseIdList', 'getNewAccountIdList']),
        ...mapGetters("dictionary", ['getCarrierCusList']),
        packStatus () {
            return [{
                value: 0,
                label: 'UNKNOWN',
                color: ''
            }, {
                value: 1,
                label: 'PRE TRANSIT',
                color: 'color-success'
            }, {
                value: 2,
                label: 'IN TRANSIT',
                color: 'color-primary'
            }, {
                value: 3,
                label: 'OUT FOR DELIVERY',
                color: 'color-warning'
            }, {
                value: 4,
                label: 'DELIVERED',
                color: ''
            }, {
                value: 5,
                label: 'AVAILABLE FOR PICKUP',
                color: 'color-success'
            }, {
                value: 6,
                label: 'RETURN TO SENDER',
                color: 'color-error'
            }, {
                value: 7,
                label: 'FAILURE',
                color: 'color-error'
            }, {
                value: 8,
                label: 'CANCELLED',
                color: ''
            },{
                value: 9,
                label: 'ERROR',
                color: 'color-error'
            },{
                value: 11,
                label: "Label Created",
                color: "",
            },]
        },
        columns() {
            let datalist = [{
                type: 'selection',
                width: 60,
            }, {
                title: this.$t('global.common.operation',{defaultValue:'操作'}),
                width: 100,
                render:this.getOperateNodes,
            }, {
                title: this.$t('erp.b2c.table_title2',{defaultValue:'账号/项目/订单号/平台订单号'}),
                minWidth:300,
                render: (h, { row }) => {
                    const id = row.lineId;
                    const rate = row.grade;
                    const product = this.getNewProductList.filter((item) => {
                        return id == item.value
                    })[0] || {};
                    var urgent = false;
                    if (row.saleOrderDetails.systemShipServiceLevel==1) {
                        urgent = true;
                    }
                    let channelItem = this.getNewAccountIdList.filter(item => {
                        return row.channelFlag == item.attach.item.flag
                    })[0] || {}
                    // 待人工审核
                    let artificial = row.isArtificial === 'Y';
                    // 待激活
                    let isActive = row.isActive === 'N';
                    return <div>
                        <div>{channelItem.label || row.channelFlag}</div>
                        <div>{row.channel}</div>
                        <div><span class="font-bold">{product.label||'-'}</span></div>
                        <div>
                            <a onClick={this.handleOperates.bind(this, row.id, 'query', row.parentId)}>{row.id}</a>
                            <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank', row.parentId)}><Icon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                        </div>
                        <div>
                            <Tooltip placement="top" content={this.$t('erp.b2c.table_urgentorder',{defaultValue:'加急订单（最晚发货时间在24小时内）'})}>
                                <span v-show={urgent} class="order-urgent-span margin-right-5" style="cursor: pointer;">{this.$t('erp.b2c.table_urgent',{defaultValue:'急'})}</span>
                            </Tooltip>
                            <Tooltip placement="top" content={this.$t('erp.b2c.artificial_order',{defaultValue:'待审核订单'})}>
                                <span v-show={artificial} class="order-active-span margin-right-5" style="cursor: pointer">{this.$t('erp.b2c.table_artificial', { defaultValue: '审' })}</span>
                            </Tooltip>
                            <Tooltip placement="top" content={this.$t('erp.b2c.actived_order',{defaultValue:'待激活订单'})}>
                                <span v-show={isActive} class="order-active-span margin-right-5" style="cursor: pointer;">{this.$t('erp.b2c.table_active', { defaultValue: '激' })}</span>
                            </Tooltip>
                            {row.orderNo}
                        </div>
                        <Rate v-show={ rate>0 } value={rate} disabled style="font-size:15px"></Rate>
                    </div>

                },
            },
            {
                title: this.$t('erp.b2c.search_orderstatus',{defaultValue:'订单状态'}),
                width:110,
                render: (h, { row }) => {
                    switch (row.orderStatus) {
                        case 'pending': return <Button class="b2cspan-error span-padding">{this.$t('erp.b2c.orderstatus_pending',{defaultValue:'未支付'})}</Button>; break;
						case 'unshipped': return <Button class="b2cspan-error span-padding">{this.$t('erp.b2c.orderstatus_unshipped',{defaultValue:'未发货'})}</Button>; break;
						case 'approved': return <Button class="b2cspan-success span-padding">{this.$t('erp.b2c.orderstatus_approved',{defaultValue:'已审核'})}</Button>; break;
						case 'assigned': return <Button class="b2cspan-primary span-padding">{this.$t('erp.b2c.orderstatus_assigned',{defaultValue:'已分配'})}</Button>; break;
						case 'picked': return <Button class="b2cspan-info span-padding">{this.$t('erp.b2c.orderstatus_picked',{defaultValue:'已配货'})}</Button>; break;
						case 'shipped': return <Button class="b2cspan-light-content span-padding">{this.$t('erp.b2c.orderstatus_shipped',{defaultValue:'已发货'})}</Button>; break;
						case 'canceled': return <Button class="b2cspan-warning span-padding">{this.$t('erp.b2c.orderstatus_canceled',{defaultValue:'已取消'})}</Button>; break;
						case 'refunded': return <Button class="b2cspan-dark-primary span-padding">{this.$t('erp.b2c.orderstatus_refunded',{defaultValue:'已退款'})}</Button>; break;
					}
                },
            },
            {
                title: this.$t('erp.b2c.table_title4',{defaultValue:'SellerSKU/销售金额'}),
                minWidth:200,
                render: (h, { row }) => {
                    let sellers = row.saleOrderItemsList.map(item=>{
                        let html = ''
                        // 不发货产品
                        if (item.isShip === 'manual') {
                            html = <div><del>{item.sellerSku ? item.sellerSku : item.erpSku}</del> * {item.quantity}</div>
                        }
                        else {
                            html = <div>{item.sellerSku ? item.sellerSku : item.erpSku} * {item.quantity}</div>
                        }
                        return html
                    })
                    let channelTotalSalesAmount = 0;
                    if (row.saleOrderItemsList.length > 0) {
                        for (var i = 0; i < row.saleOrderItemsList.length; i++) {
                            channelTotalSalesAmount = channelTotalSalesAmount + row.saleOrderItemsList[i].channelTotalSalesAmount
                        }
                    }
                    return <div>
                        <div >{sellers}</div>
                        <div v-show={this.b2cPriceInfo == true} class="font-bold">{row.amount} {row.currencyCode}
                            <span v-show={channelTotalSalesAmount > 0}> (
                            <span style="color: red">
                                        {channelTotalSalesAmount.toFixed(2)} { row.currencyCode }</span>)</span></div>
                        <div class="b2ccolor-warning font-weight" v-show={row.fulfillmentChannel=='MFN'}>{row.fulfillmentChannel}</div>
                        <div class="b2ccolor-success font-weight" v-show={row.fulfillmentChannel=='AFN'}>{row.fulfillmentChannel}</div>
                    </div>
                },

            },
                {
                    title: 'img',
                    minWidth:150,
                    // width:200,
                    render: (h, { row }) => {
                        let saleOrderItemsList = row.saleOrderItemsList;
                        let image = saleOrderItemsList[0].imageUrl;
                        if (image) {
                            return <div>
                                <div style="float: left; cursor: pointer; margin-right: 10px;">
                                    <img style="width: 100px; height: 100px;" src={image}></img>
                                </div>
                            </div>;
                        } else {
                            return <div>
                                <div><span>-</span></div>
                            </div>;
                        }

                    },
                },
            {
                title: this.$t('erp.b2c.table_title5',{defaultValue:'仓库/发货Carrier/发货方式'}),
                minWidth:250,
                render: (h, { row }) => {
                    const className = row.orderClass == 'b2b' || row.orderClass == 'b2b_pla' ? 'iconfont icon-tuopan_pallet' : row.orderClass == 'b2c' ? 'iconfont icon-kuaidi' : '';
                    const descriptionName = row.orderClass == 'b2b' ? this.$t('erp.b2c.goods_collection_tooltip',{defaultValue:'集货出库-不上报打托信息'}) : row.orderClass == 'b2c' ? this.$t('erp.b2c.direct_issue_tooltip',{defaultValue:'直接出库'}) : row.orderClass == 'b2b_pla' ? this.$t('erp.b2c.goods_collection_underpinning_tooltip',{defaultValue:'集货出库-上报打托信息'}) :'';
                    if(row.orgWarehouseId!=0){
                        const id = row.orgWarehouseId,
                            result = this.getNewWarehouseIdList.filter((item) => {
                                return item.value == id;
                            })[0] || {};
                        return <div>
                                <div>{result.label}</div>
                                <div>{row.saleOrderDetails.carrier ||'-'} </div>
                                <div>{row.shippingMethodCode ||'-'}</div>
                                <Tooltip placement="top" content={descriptionName}>
                                    <div style="font-size: 16px; color: #00adff" class={className}></div>
                                </Tooltip>
                            </div>
                    }else{
                        return <div>
                            <div>{this.$t('erp.b2c.table_title5_desc',{defaultValue:'未分配到仓库'})}</div>
                            <div>{row.saleOrderDetails.carrier ||'-'} </div>
                            {/* ({this.findRenderLabel(this.getCarrierCusList, row.carrierAccountGroupId) || '--'}) */}
                            <div>{row.shippingMethodCode ||'-'}</div>
                            <Tooltip placement="top" content={descriptionName}>
                                <div style="font-size: 16px; color: #00adff" class={className}></div>
                            </Tooltip>
                        </div>
                    }
                },
            },
            {
                title:this.$t('erp.b2c.table_title6',{defaultValue:'订单类型/标记/标签'}),
                minWidth:230,
                className: 'b2c-table-column-show-all',
                render:(h, { row })=>{
                    var ordertype;
					switch (row.orderType) {
                        case 'normally': ordertype = <div class="b2ccolor-dark-primary font-weight span-padding">{this.$t('erp.b2c.ordertype_normally',{defaultValue:'正常销售'})}</div>; break;
						case 'celebrity': ordertype = <div class="b2ccolor-error font-weight span-padding">{this.$t('erp.b2c.ordertype_celebrity',{defaultValue:'展示订单'})}</div>; break;
						case 'distribution': ordertype = <div class="b2ccolor-success font-weight span-padding">{this.$t('erp.b2c.ordertype_distribution',{defaultValue:'分销订单'})}</div>; break;
						case 'brush': ordertype = <div class="b2ccolor-warning font-weight span-padding">{this.$t('erp.b2c.ordertype_brush',{defaultValue:'刷评订单'})}</div>; break;
                        case 'DELIVERY': ordertype = <div class="b2ccolor-warning font-weight span-padding">{this.$t('erp.b2c.ordertype_delivery',{defaultValue:'发货订单'})}</div>; break;
					}
                    const urls = {
                        isCelebrity:'/picture/hongren.png',
                        isSample:'/picture/yangpin.png',
                        isReshipment:'/picture/bufa.png',
                        isDismantlementfu:'/picture/chaifu.png',
                        isDismantlementzi:'/picture/chaizi.png',
                        isAddition:'/picture/lipin.png',
                    }
                    const titles = {
                        isCelebrity:this.$t('erp.b2c.redpeople_order',{defaultValue:'红人订单'}),
                        isSample:this.$t('erp.b2c.sample_order',{defaultValue:'样品订单'}),
                        isReshipment:this.$t('erp.b2c.replacement_order',{defaultValue:'补发订单'}),
                        isDismantlementfu:this.$t('erp.b2c.unpackparent_order',{defaultValue:'拆解父订单'}),
                        isDismantlementzi:this.$t('erp.b2c.unpackson_order',{defaultValue:'拆解子订单'}),
                        isAddition:this.$t('erp.b2c.gift_order',{defaultValue:'礼品订单'}),
                    }
                    var imgs = ['isCelebrity','isSample','isReshipment','isDismantlement','isAddition'].map((val)=>{
                        if( val =='isDismantlement' &&row['isDismantlement'] == 'Y' && row.parentId == 0){
                            return h('span',[
                                h('Tooltip',{
                                    props:{
                                        placement:'top',
                                        transfer:true,
                                        content:titles['isDismantlementfu']
                                    }
                                },[
                                    h('img',{
                                        attrs:{
                                            src:urls['isDismantlementfu'],
                                            style:"width:20px;height:20px;cursor: pointer;"
                                        },
                                    })
                                ])
                            ])
                        }else if(val =='isDismantlement' && row['isDismantlement'] == 'Y' && row.parentId !=0 ){
                            return h('span',[
                                h('Tooltip',{
                                    props:{
                                        placement:'top',
                                        transfer:true,
                                        content:titles['isDismantlementzi']
                                    }
                                },[
                                    h('img',{
                                        attrs:{
                                            src:urls['isDismantlementzi'],
                                            style:"width:20px;height:20px;cursor: pointer;"
                                        },
                                    })
                                ])
                            ])
                        }else{
                            return row[val]== 'Y' ? h('span',[
                                h('Tooltip',{
                                    props:{
                                        placement:'top',
                                        transfer:true,
                                        content:titles[val]
                                    }
                                },[
                                    h('img',{
                                        attrs:{
                                            src:urls[val],
                                            style:"width:20px;height:20px;cursor: pointer;"
                                        },
                                    })
                                ])
                            ]) : ''
                        }
                    })
                    var orderFont;
                    if(row.isPrime == 'Y'){
                        orderFont = <span class="b2cfont-italic b2ccolor-info">Prime</span>
                    }else if(row.isOnsite == 'Y'){
                        orderFont = <span class="b2cfont-italic b2ccolor-content">Onsite</span>
                    }else if(row.isBusinessOrder == 'Y'){
                        orderFont = <span class="b2cfont-italic b2ccolor-error">Business</span>
                    }else if(row.shipmentType == 1){
                        orderFont = <span class="b2cfont-italic b2ccolor-warning">Store</span>
                    }
                    var errorcode;
                    switch (row.errorCode) {
                        case 'insufficientInventoryException': errorcode = this.$t('erp.b2c.errorcode_insufficientInventoryException', { defaultValue: '库存不足' }); break;
                        case 'deliverOrderCancelException': errorcode = this.$t('erp.b2c.errorcode_deliverOrderCancelException', { defaultValue: '配货单取消异常' }); break;
						case 'systemException': errorcode = this.$t('erp.b2c.errorcode_systemException',{defaultValue:'系统异常'}); break;
                        case 'configurationException': errorcode = this.$t('erp.b2c.configuration_exception',{defaultValue:'配置异常'}); break;
						case 'produceException': errorcode = this.$t('erp.b2c.errorcode_produceException',{defaultValue:'商品无法关联'}); break;
						case 'addressException': errorcode = this.$t('erp.b2c.errorcode_addressException',{defaultValue:'订单地址异常'}); break;
                        case 'updateException': errorcode = this.$t('erp.b2c.errorcode_updateException',{defaultValue:'订单更新异常'}); break;
						case 'pickingException': errorcode = this.$t('erp.b2c.errorcode_pickingException',{defaultValue:'订单配货异常'}); break;
						case 'cancelException': errorcode = this.$t('erp.b2c.errorcode_cancelException',{defaultValue:'订单取消异常'}); break;
						case 'trackingException': errorcode = this.$t('erp.b2c.errorcode_trackingException',{defaultValue:'Tracking异常'}); break;
                        case 'costException': errorcode = this.$t('erp.b2c.errorcode_costException',{defaultValue:'订单成本异常'}); break;
						case 'carrierException': errorcode = this.$t('erp.b2c.errorcode_carrierException',{defaultValue:'订单发运方式异常'}); break;
                        case 'uploadException': errorcode = this.$t('erp.b2c.errorcode_uploadException',{defaultValue:'订单附件上传异常'}); break;
                        case 'purchaseException': errorcode = this.$t('erp.b2c.errorcode_buylabelException', { defaultValue: '购买面单异常' }); break;
                    }
                    // console.log('row', row.orderLabelEntities);
                    let label = [];
                    row.orderLabelEntities.forEach(labelItem => {
                        this.labelList.map(item => {
                            if (item.labelId === labelItem.labelId) label.push(item);
                        })
                    });
                    // console.log('label',label);
                    let labelArray = [];
                    labelArray = label.map(item => {
                        if(item.labelId!=7){
                            return (
                                <Tooltip content={item.labelName}>
                                    <div class={`color-${item.labelColour} margin-right-5`} style={`
                                        float: left;
                                        color: #fff;
                                        text-align: center;
                                        padding: 3px 5px;
                                        max-width: 155px;
                                        min-width: 40px;
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        white-space: nowrap;
                                        word-break: break-all;
                                        margin-bottom: 5px;
                                    `}>{item.labelName}</div>
                                </Tooltip>
                            )
                        }else{
                            return (
                                <Tooltip content={item.labelName}>
                                    <div onClick={this.handleOperates.bind(this, row, 'getReplacementDetails')} class={`color-${item.labelColour} margin-right-5`} style={`
                                        float: left;
                                        color: #fff;
                                        text-align: center;
                                        padding: 3px 5px;
                                        max-width: 155px;
                                        min-width: 40px;
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        white-space: nowrap;
                                        word-break: break-all;
                                        margin-bottom: 5px;
                                        cursor:pointer;
                                    `}>{item.labelName}</div>
                                </Tooltip>
                            )
                        }
                    })
                    let orderId = row.id;
                    // console.log('selected', label);
                    let compLabelSelect = h('compLabelSelect', {
                        style: {
                            top: '-6px'
                        },
                        props: {
                            dataList: this.labelList.filter(item=>item.labelType!==1),
                            selected: label,
                            needRefresh: true,
                            modalProps: {
                                title: this.$t('erp.b2corder.label_label_font', { defaultValue: '标签' })
                            }
                            // hideMain: true,
                            // slot: "main"
                        },
                        attrs: {
                            size: 'small'
                        },
                        on: {
                            'on-add': (type, selected) => {
                                label.map(item=>{
                                    if(item.labelType===1){
                                        selected.push(item.labelId)
                                    }
                                })
                                HttpOrderAddLabel({
                                    labelIds: selected.join(','),
                                    orderIds: orderId,
                                    singleFlag: 1
                                }).then(res => {
                                    // this.$VMessage.success(res.message);
                                    this.$nextTick(() => {
                                        // this.$refs.compsearch.formData['IN_orderLabelEntities.labelId'] = '';
                                        // this.updateSearch({ search: this.$refs.compsearch.formData });
                                        this.updateSearch();
                                    });
                                }, err => {
                                    this.$VMessage.error(err.message);
                                });
                            },
                            'on-remove': (type, selected) => {
                                label.map(item=>{
                                    if(item.labelType===1){
                                        selected.push(item.labelId)
                                    }
                                })
                                HttpOrderRemoveLabel({
                                    labelIds: selected.join(','),
                                    orderIds: orderId
                                }).then(res => {
                                    // this.$VMessage.success(res.message);
                                    this.$nextTick(() => {
                                        // this.$refs.compsearch.formData['IN_orderLabelEntities.labelId'] = '';
                                        // this.updateSearch({ search: this.$refs.compsearch.formData });
                                        this.updateSearch();
                                    });
                                }, err => {
                                    this.$VMessage.error(err.message);
                                });
                            },
                            'on-change': (type, changeMap) => {
                                changeMap.forEach(async (value, key, map) => {
                                    await HttpSaveLabel({
                                        id: key,
                                        labelId: value.labelId,
                                        labelName: value.labelName,
                                        labelColour: value.labelColour,
                                        module: 26
                                    }).then(res => {
                                        // this.$VMessage.success(res.message);
                                        this.labelList = res.data;
                                    }, err => {
                                        this.$VMessage.error(err.message);
                                    });
                                })
                                // setTimeout(() => {
                                //     this.getLabelData();
                                // }, 200);
                            },
                            // 'on-confirm-change': (selected, unSelected) => {
                            'on-confirm-change': (selected) => {
                                label.map(item=>{
                                    if(item.labelType===1){
                                        selected.push(item.labelId)
                                    }
                                })
                                // 批量修改
                                HttpOrderAddLabel({
                                    labelIds: selected.join(','),
                                    orderIds: orderId,
                                    singleFlag: 1
                                }).then(res => {
                                    this.updateSearch({ search: this.$refs.compsearch.formData });
                                }, err => {
                                    this.$VMessage.error(err.message);
                                });
                                // // 添加
                                // let promiseA = new Promise((resolve, reject) => {
                                //     if (!selected.length) return resolve();
                                //     HttpOrderAddLabel({
                                //         labelIds: selected.join(','),
                                //         orderIds: orderId,
                                //         singleFlag: 1
                                //     }).then(res => {
                                //         resolve(res);
                                //     }, err => {
                                //         reject(err);
                                //     });
                                // });
                                // let promiseB = new Promise((resolve, reject) => {
                                //     if (!unSelected.length) return resolve();
                                //     // 移除
                                //     HttpOrderRemoveLabel({
                                //         labelIds: unSelected.join(','),
                                //         orderIds: orderId
                                //     }).then(res => {
                                //         resolve(res);
                                //     }, err => {
                                //         reject(err);
                                //     });
                                // })
                                // Promise.all([promiseA, promiseB]).then(res => {
                                //     // this.$VMessage.success(res[0].message);
                                //     this.$nextTick(() => {
                                //         // this.$refs.compsearch.formData['IN_orderLabelEntities.labelId'] = '';
                                //         this.updateSearch({ search: this.$refs.compsearch.formData });
                                //         // this.updateSearch();
                                //     });
                                // }, err => {
                                //     console.log(err);
                                //     this.$VMessage.error(err.message);
                                // });
                            }
                        }
                    }, [
                        h('Icon', {
                            attrs: {
                                type: 'ios-brush'
                            }
                        })
                    ])
                    return <div>
                        <div>{ordertype}{imgs}</div>
                        <div class="margin-bottom-5">{orderFont}</div>
                        <div class="margin-bottom-5" v-show={errorcode}><span class="error-span margin-right-10">{errorcode}</span></div>
                        <div v-show={labelArray.length} style="position: relative; display: flex;">
                            <div v-show={labelArray.length} style="position: relative;">
                                {labelArray}
                            </div>
                            <div style="font-size: 20px;">
                                {compLabelSelect}
                            </div>
                        </div>
                    </div>;
                }
            },
                {
                    renderHeader:(h)=>{
                        return h('div', {style:'display:inline-block'},[
                            h('Tooltip', {
                                    props: {
                                        "max-width":"200",
                                        placement: 'top',
                                        transfer: true,
                                        content: this.$t('global.common.ordertimetip',{defaultValue:'下单时间标识'}),
                                    }
                                }, [
                                    h('strong', this.$t('global.common.ordertime',{defaultValue:'下单时间'})),
                                    h('Icon', {
                                        props: {
                                            type: "md-help-circle",
                                            class:"font-14",
                                        },
                                    }),
                                ]
                            )
                        ])
                    },
                    minWidth:220,
                    key:'accountLocalTime',
                    sortable:true,
                    render: (h, { row }) => {
                        let channelItem = this.getNewAccountIdList.filter(account => {
                            return row.channelFlag == account.attach.item.flag
                        })[0] || {}
                        return <div>
                            <div>{row.saleOrderDetails.accountLocalTime ||'--'}({channelItem.attach?channelItem.attach.item.timeZone:'--'})</div>
                        </div>
                    },
                },
                {
                title: this.$t('erp.b2c.last_Scan_Date',{defaultValue:'最晚扫描时间'}),
                minWidth:200,
                key:'saleOrderDetails.lastScanDate',
                sortable:true,
                render: (h, { row }) => {
                    return <div>
                        <div>{row.saleOrderDetails.lastScanDate ||'-'}</div>
                    </div>

                },
            },
            {
                title: this.$t('erp.b2c.table_title8',{defaultValue:'物流状态'}),
                minWidth: 200,
                key: 'logisticStatus',
                render: (h, { row }) => {
                    let font = '';let trackNo='';
                    if(row.saleShipmentPackagesList.length>0){
                        font = this.getLogistics(row.saleShipmentPackagesList[0].logisticStatus);
                        trackNo = row.saleShipmentPackagesList[0].trackNo
                        // 发货方式MFN 订单状态已发货
                        if (row.fulfillmentChannel === 'MFN' && row.orderStatus === 'shipped') {
                            let url = ''
                            // console.log(trackNo.slice(0,2),'trackNo.slice(0,2)')
                            if (trackNo.slice(0,2) === '1Z') {
                                url = `https://www.ups.com/track?loc=zh_CN&tracknum=${trackNo}&requester=WT/tracksummary`
                            }
                            else {
                                url = `https://www.fedex.com/apps/fedextrack/?action=track&tracknumbers=${trackNo}&locale=en_US&cntry_code=ratetools`
                            }
                            font = <a target="_blank" href={url}>{font}</a>
                        }
                    }
                    return <div>
                        <div>
                            <span v-show={font}>{font}</span>
                            <span v-show={!font}>--</span>
                        </div>
                        <div>
                            <a v-show={trackNo} onClick={this.handleOperates.bind(this, row.saleShipmentPackagesList, 'querylogistic')}>{trackNo || '--'}</a>
                            <span v-show={!trackNo}>--</span>
                        </div>
                        <div>
                            {row.shippingfee + ' ' + row.currencyCode}
                        </div>
                    </div>
                }
            },
            {
                title: this.$t('global.common.createdtime',{defaultValue:'创建时间'}),
                minWidth:200,
                key:'channelCreated',
                sortable:true,
                render: (h, { row }) => {
                    return <div>
                        <div>{row.channelCreated ||'-'}</div>
                    </div>

                },
            },
                {
                    renderHeader:(h)=>{
                        return h('div', {style:'display:inline-block'},[
                            h('Tooltip', {
                                    props: {
                                        "max-width":"200",
                                        placement: 'top',
                                        transfer: true,
                                        content: this.$t('global.common.requestcomment',{defaultValue:'请求评论状态标识'}),
                                    }
                                }, [
                                    h('strong', this.$t('boss.order.comment_status',{defaultValue:'请求评论状态'})),
                                    h('Icon', {
                                        props: {
                                            type: "md-help-circle",
                                            class:"font-14",
                                        },
                                    }),
                                ]
                            )
                        ])
                    },
                    // title: this.$t('',{defaultValue:'请求评论状态'}),
                    minWidth:140,
                    key:'invitationStatus',
                    render: (h, { row }) => {
                        let status = row.invitationStatus || 0
                        return <div>
                            <div>{this.inviteCount.filter(item=>item.value == status)[0].label}</div>
                        </div>

                    },
                },
            {
                title: this.$t('erp.b2c.latest_time',{defaultValue:'最晚发货时间'}),
                minWidth:200,
                key:'latestShipDate',
                sortable:true,
                render: (h, { row }) => {
                    return <div>
                        <div>{row.latestShipDate ||'-'}</div>
                    </div>

                },
            },
            {
                title: this.$t('erp.b2c.expected_time',{defaultValue:'仓库预计发货时间'}),
                minWidth:200,
                key:'saleOrderDetails.warehouseExpectedShipDate',
                sortable:true,
                render: (h, { row }) => {
                    return <div>
                        <div>{row.saleOrderDetails.warehouseExpectedShipDate ||'-'}</div>
                    </div>

                },
            },
            {
                title: this.$t('erp.b2c.Promise_delivery_time',{defaultValue:'承诺妥投时间'}),
                minWidth:200,
                key:'saleOrderDetails.promisedDeliveryDate',
                sortable:true,
                render: (h, { row }) => {
                    return <div>
                        <div>{row.saleOrderDetails.promisedDeliveryDate ||'-'}</div>
                    </div>

                },
            },
            ];
            return datalist;
        },
    },
};




